import * as Yup from 'yup';

export const amlKVFormValidationSchema = Yup.object().shape({
  subscription: Yup.string().required(),
  resourceGroup: Yup.string().required(),
});
